import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventDTO } from '../../../../app/api/models';

@Component({
  selector: 'app-choose-event-dialog',
  templateUrl: './choose-event-dialog.component.html',
  styleUrls: ['./choose-event-dialog.component.scss']
})
export class ChooseEventDialogComponent {


  filteredEvents: any[] = [];
  searchText: string = "";

  constructor(
    public dialogRef: MatDialogRef<ChooseEventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  confirmClick(): void {
    this.dialogRef.close(this.data.selectedEvent);
  }

  isSelectedEvent(event: EventDTO) {
    return JSON.stringify(event) === JSON.stringify(this.data.selectedEvent);
  }

  hasSelectEvent(event: EventDTO) {
    this.data.selectedEvent = event;
  }

  searchEvent() {
    this.filteredEvents = this.data.events.filter((event: any) => {
      return event.title.toLowerCase().includes(this.searchText);
    })
    this.data.selectedEvent = undefined;
  }

  resetSearch(){
    this.searchText = '';
    this.filteredEvents = [];
  }
}
